import * as React from 'react';
import { getNativeElementProps, isResolvedShorthand, resolveShorthand, useEventCallback } from '@fluentui/react-utilities';
import { useAccordionItemContext_unstable } from '../AccordionItem/index';
import { useARIAButtonShorthand } from '@fluentui/react-aria';
import { useAccordionContext_unstable } from '../Accordion/AccordionContext';
import { ChevronRightRegular } from '@fluentui/react-icons';
import { useFluent_unstable as useFluent } from '@fluentui/react-shared-contexts';
/**
 * Returns the props and state required to render the component
 * @param props - AccordionHeader properties
 * @param ref - reference to root HTMLElement of AccordionHeader
 */ export const useAccordionHeader_unstable = (props, ref)=>{
    const { as , icon , button , expandIcon , inline =false , size ='medium' , expandIconPosition ='start'  } = props;
    const { onHeaderClick: onAccordionHeaderClick , disabled , open  } = useAccordionItemContext_unstable();
    /**
   * force disabled state on button if accordion isn't collapsible
   * and this is the only item opened
   */ const disabledFocusable = useAccordionContext_unstable((ctx)=>!ctx.collapsible && ctx.openItems.length === 1 && open);
    const { dir  } = useFluent();
    // Calculate how to rotate the expand icon [>] (ChevronRightRegular)
    let expandIconRotation;
    if (expandIconPosition === 'end') {
        // If expand icon is at the end, the chevron points up [^] when open, and down [v] when closed
        expandIconRotation = open ? -90 : 90;
    } else {
        // Otherwise, the chevron points down [v] when open, and right [>] (or left [<] in RTL) when closed
        expandIconRotation = open ? 90 : dir !== 'rtl' ? 0 : 180;
    }
    return {
        disabled,
        open,
        size,
        inline,
        expandIconPosition,
        components: {
            root: 'div',
            button: 'button',
            expandIcon: 'span',
            icon: 'div'
        },
        root: getNativeElementProps(as || 'div', {
            ref,
            ...props
        }),
        icon: resolveShorthand(icon),
        expandIcon: resolveShorthand(expandIcon, {
            required: true,
            defaultProps: {
                children: /*#__PURE__*/ React.createElement(ChevronRightRegular, {
                    style: {
                        transform: `rotate(${expandIconRotation}deg)`
                    }
                }),
                'aria-hidden': true
            }
        }),
        button: resolveShorthand({
            ...useARIAButtonShorthand(button, {
                required: true,
                defaultProps: {
                    disabled,
                    disabledFocusable,
                    'aria-expanded': open,
                    type: 'button'
                }
            }),
            onClick: useEventCallback((ev)=>{
                if (isResolvedShorthand(button)) {
                    var _button_onClick;
                    (_button_onClick = button.onClick) === null || _button_onClick === void 0 ? void 0 : _button_onClick.call(button, ev);
                }
                if (!ev.defaultPrevented) {
                    onAccordionHeaderClick(ev);
                }
            })
        }, {
            required: true
        })
    };
};
